module.exports = __webpack_public_path__ + "static/media/filter-outline.848ae823.svg";